import { render, staticRenderFns } from "./sportbook-country.vue?vue&type=template&id=2679ad36&scoped=true&"
import script from "./sportbook-country.vue?vue&type=script&lang=js&"
export * from "./sportbook-country.vue?vue&type=script&lang=js&"
import style0 from "./sportbook-country.vue?vue&type=style&index=0&id=2679ad36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2679ad36",
  null
  
)

export default component.exports